import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M16.15 13.05 14 16.5q-.275.425-.762.35-.488-.075-.613-.575l-.7-2.8L5.1 20.3a.98.98 0 0 1-.688.287.93.93 0 0 1-.712-.287.95.95 0 0 1-.275-.7.95.95 0 0 1 .275-.7l6.825-6.85-2.8-.7q-.5-.124-.575-.612t.35-.763l3.45-2.125-.3-4.075q-.05-.5.4-.725t.825.1L15 5.775l3.775-1.525q.475-.2.825.15t.15.825L18.225 9l2.625 3.1q.325.375.1.825t-.725.4zm-12.8-6.7a.48.48 0 0 1 0-.7l1.3-1.3a.48.48 0 0 1 .7 0l1.3 1.3a.48.48 0 0 1 0 .7l-1.3 1.3a.48.48 0 0 1-.7 0zm10.525 6.575 1.2-1.975 2.325.175-1.5-1.775.875-2.15-2.15.875L12.85 6.6l.175 2.3-1.975 1.225 2.25.55zm3.775 7.725-1.3-1.3a.48.48 0 0 1 0-.7l1.3-1.3a.48.48 0 0 1 .7 0l1.3 1.3a.48.48 0 0 1 0 .7l-1.3 1.3a.48.48 0 0 1-.7 0" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }